export const goToGrooveCalender = (onboard: boolean) => {
  if (typeof window !== "undefined") {
    onboard
      ? window.open("https://meetings.grooveapp.com/r2cainqw/Eventr")
      : window.open(
          "https://meetings.grooveapp.com/vrtoh9dr/-Eventbrite-Help-Center-Consultation-?embedType=INLINE"
        )
  }
}
